import { ACTION_TYPES, STATUSES } from "../../util/constants";
import { addAlert } from "./slices/global-alerts-slice";
import AlertEndpointManager from "./alert-endpoint-manager";

// optimized set created from API calls: query/mutation - fulfilled/rejected
const ACTION_TYPES_SET = new Set(Object.values(ACTION_TYPES));

export const alertMiddleware = store => next => action => {
  const result = next(action);
  if (!ACTION_TYPES_SET.has(action.type)) { return result }

  const { isRejectedAction, isFulfilledAction } = AlertEndpointManager(action)
  if (!isRejectedAction && !isFulfilledAction) { return result }

  let message = ''
  let severity = ''

  if (isRejectedAction) {
    message = action.error?.message || 'Failed to complete request.';
    severity = STATUSES.ERROR;
  } else if (isFulfilledAction) {
    const { payload } = action;
    message = payload?.alert?.message || 'Task completed successfully.';
    severity = STATUSES.SUCCESS;
  } else {
    message = "Unknown error. Please contact an administrator."
    severity = STATUSES.WARNING;
  }

  store.dispatch(addAlert({ message, severity }));
  return result
};

export default alertMiddleware